import { ReactNode } from 'react';
import cn from 'classnames';
import styles from './Table.module.scss';
import { useTableRowContext } from './TableRowContext';

interface TableCellProps {
  children: ReactNode;
  hidden?: boolean;
  className?: string;
  /** Если true — ячейка не оборачивается в <a> даже при наличии href в контексте строки.
   *  Используется для ячеек с чекбоксами и кнопками действий. */
  noLink?: boolean;
}

export const TableCell = ({
  children,
  hidden,
  className,
  noLink,
}: TableCellProps): JSX.Element => {
  const { href } = useTableRowContext();

  return (
    <td
      className={cn(
        styles.tableCell,
        hidden && styles.tableCellHidden,
        className
      )}
    >
      {href && !noLink ? (
        <a
          href={href}
          className={styles.tableCellLink}
          onClick={e => e.preventDefault()}
          tabIndex={-1}
        >
          {children}
        </a>
      ) : (
        children
      )}
    </td>
  );
};
